import { Component } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { BreadCrumbOptions, SettingsBreadCrumbService } from '../../settings-breadcrumb.service';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';

@Component({
    templateUrl: './account-roles-permissions.page.html'
})
export class AccountRolesPermissionsPage {
    public UsersUrl: string = PKIUrls.UsersUrl;

    currentUserGuid!: string;
    constructor(private settingsService: SettingsService, private settingsBreadCrumbService : SettingsBreadCrumbService) {
        this.currentUserGuid = this.settingsService.currentUserId;
        // set the settings breadcrumb to the correct options:
        this.settingsBreadCrumbService.SetCrumbs(BreadCrumbOptions.Account, BreadCrumbOptions.Account_Roles);
    }
}
